import React,{useContext, useState,useLayoutEffect,useRef} from 'react'
import LeftNavMenu from "./common/Navbar";
import '../styles/Unclaimed-CME-Dashboard.css';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { Button, Link, styled, Typography } from "@mui/material";
import shortid from  "shortid";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { useQueryClient } from "@tanstack/react-query";
import apiUsers from "../api-operation";
import {contactContext} from '../context/contactContext';
import { BrowserRouter, useHistory } from 'react-router-dom';
import EmptyProgress from '../images/ActivityEmpty.png'
import { promiseContext } from '../context/promiseContext';
import {userContext} from "../context/userContext";
import {GetActivitiesDeletedByAdminData} from '../utils/cache';
import LearnerProfileHeader from './LearnerProfileHeader';
import { FEATURE_Phase_2_MERGE_CME } from '../config/config';
import Container from './CMEProfileManagement/ModalContainer';
import {Snackbar, Stack } from "@mui/material";
import Alert from "../components/common/Alert";

export function DeletedActivitiesByAdmin(props:any){
    const [DeletedActivitesList,setDeletedActivitesList] = useState<[IDeletedActivityDetails]|[]>([]);
    const [claimedLoaded, setclaimedLoaded] = useState(false);
    const [order, setOrder] = useState({ Date: 'asc', Name: 'asc' });   
    const [openAlertMsg, setOpenAlertMsg] = React.useState(false);
    const queryClient = useQueryClient();

    let contactObject  = useContext(contactContext);
    const history = useHistory();   
    let contactData = contactObject.contactObject.Contact; 

    const msg = "Activity restored Successfully!";

    const [isNavExpanded, setIsNavExpanded] = React.useState(false);   
       
    const [updateContact, setupdateContact] = useState(false);

    let trackingArray : any =[];

    let promiseValue = React.useContext(promiseContext) as PromiseType;
      //For Left Nav Height
      const ref = useRef<HTMLInputElement>(null);
      const [height, setHeight] = useState(0);
      const [loadNavHeight, setLoadNavHeight] = useState(false);
      
      let userObject = useContext(userContext);
      let userData = userObject.User;
      //check user is admin or not
    let isAdmin:boolean = userData.acepMemberStatus === 2 ? true : false;

      if(userData.acepMemberStatus === 2){
        contactData =contactObject.contactObject.Contact;
        if(!updateContact)
        setupdateContact(true);
      }
      else{
            contactData =contactObject.contactObject.Contact;
      }

      useLayoutEffect(()=>{
        
        
          var HomePagebackgroundHeight = document.body.getElementsByClassName('HomePagebackground')[0]; // Assuming there's only one element with class 'HomePagebackground'
          var currentHeight = HomePagebackgroundHeight.clientHeight; // Get the current height of the element
          var newHeight = currentHeight + 120; 
          setHeight(newHeight);
          setLoadNavHeight(false)
        
      },[loadNavHeight])

      function getArrow(order: string) {
        if (order === 'asc') 
        // return <div className='tracking-sort-arrow'><ArrowDownwardIcon fontSize='small' htmlColor='#8B8B8B'/> </div>;
        // return <div className='tracking-sort-arrow'> <ArrowUpwardIcon fontSize='small' htmlColor='#8B8B8B'/> </div>;
        // if (order === 'asc') 
        return <span style={{cursor:'pointer', verticalAlign:'top' }}><ArrowDownwardIcon fontSize='small' htmlColor='#8B8B8B'/> </span>;
        return <span style={{cursor:'pointer', verticalAlign:'top' }}> <ArrowUpwardIcon fontSize='small' htmlColor='#8B8B8B'/> </span>;
    }

  
function handleClick(target :any) {
  if (target === 'Date') {
    if (order.Date === 'asc') {
      setOrder({
        Date: 'desc',
        Name: order.Name,
      });

      const sortedAscending = DeletedActivitesList.sort(
        (a, b) => new Date(a.DeletedByAdminDate).valueOf() - new Date(b.DeletedByAdminDate).valueOf()
      );

      setDeletedActivitesList(sortedAscending);
    } else {
      setOrder({
        Date: 'asc',
        Name: order.Name,
      });

      const sortedDescending = DeletedActivitesList.sort(
        (a, b) => new Date(b.DeletedByAdminDate).valueOf() - new Date(a.DeletedByAdminDate).valueOf()
      );

      setDeletedActivitesList(sortedDescending);
    }
  } else if (target === 'Name') {
    if (order.Name === 'asc') {
      setOrder({
        Date: order.Date,
        Name: 'desc',
      });

      const sortedAscending = DeletedActivitesList.sort(
        (a, b) => (a.DeletedActivityName > b.DeletedActivityName  ? 1 : -1)
      );

      setDeletedActivitesList(sortedAscending);
    } else {
      setOrder({
        Date: order.Date,
        Name: 'asc',
      });

      const sortedDescending = DeletedActivitesList.sort(
        (a, b) => (a.DeletedActivityName  < b.DeletedActivityName ? 1 : -1)
      );

      setDeletedActivitesList(sortedDescending);
    }
  }
}

function removeQueriesForAdmin() {
  queryClient.removeQueries({ queryKey: ["unclaimedCMEFilterData"] });
  queryClient.removeQueries({ queryKey: ["claimedCMEFilterData"] });
  queryClient.removeQueries({ queryKey: ["claimedCMEData"] });
  queryClient.removeQueries({ queryKey: ["unclaimedCMEData"] });
  

  setOpenAlertMsg(true);

}

function RestoreDeletedActivity(ev: any, CmeTrackingId: string) {
 try{
  props.showSpinner(true);
  apiUsers.url ="cmeactivity/restoreDeletedActivity/" + CmeTrackingId;
        apiUsers.put({}).then((data: any) => {
          console.log(data.status)
          if(data.status === 200){
            GetDeletedRecords();
            removeQueriesForAdmin();
             
          }
        })
  }
  catch(error){
   console.log(error);
 }
 finally{
   ev.preventDefault();
    
 }
}

const GetDeletedRecords = () => {
  try{   
    props.showSpinner(true);
    apiUsers.url ="cmetracking/deletedrecords/" + contactData?.contactid;
    apiUsers.getAll().then((data: any) => {
        var rows = data.deletedactivities?.rows ;

         
                   
        for (let index = 0; index < rows.length; index++) {
          const listObject: any = {};
          let element: IDeletedActivityDetails = rows[index];
          listObject["DeletedByAdminName"] = element.DeletedByAdminName;
          listObject["DeletedByAdminDate"] = element.DeletedByAdminDate;
          listObject["DeletedActivityName"] = element.DeletedActivityName;
          listObject["CmeTrackingId"] = element.CmeTrackingId;
      
          trackingArray.push(listObject);
        }

            setDeletedActivitesList(trackingArray);
            setclaimedLoaded(true);
            setLoadNavHeight(true);
            props.showSpinner(false);
    }) 
  } catch (error) {
    console.log(error);
  }
  finally{
    
  } 

}
    React.useEffect(() => {
      if(userData.acepMemberStatus !== 2 )
      {
        history.push("/")
      }
     if(contactData?.contactid && DeletedActivitesList.length === 0)
      {
        GetDeletedRecords();
      }
      // Keyed on the contact id, not [] — the contact is empty on mount while contactContext
      // resolves the proxied learner, so a mount-only fetch would never run at all.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      },[contactData?.contactid]);
    
  return(
   <>
    <div ref={ref} className= {isAdmin ? 'UnclaimedDashboard HomePagebackground adminView' :'UnclaimedDashboard HomePagebackground'} style={{pointerEvents:props.progressStyles.pointer, opacity:props.progressStyles.opacity}}> 
        <div    className="HomePageWrapper ">
            <div style={{float:'left',width:'5%'}}>
                <LeftNavMenu heightDashboardPage={height} onCollapse={(isNavExpanded:any) => {
                    setIsNavExpanded(isNavExpanded);
                }} />
            </div>

            <div   className={isNavExpanded ? 'Right-Div-Dashboard-expanded overlay' : 'Right-Div-individual-Dashboard'}>

                <LearnerProfileHeader />
                <div  className="UncalimedDashboard-Heading">
                    <div className="div-left">
                     Deleted Records
                    </div> 
                    
                </div>

                <div >
                { DeletedActivitesList && DeletedActivitesList.length > 0?  
                    <div style={{top:'230px'}} >  
                       <>                                     
                       <div className='FourthRow box-style'>                     
                        <div  className='deletedActivities MostRecent-header-line'>                    
                            <div style={{float: "left",textAlign: "left", flex:'6'}} onClick={() => handleClick("Name")} className='box-inner-header'>Activity Name 
                              <> {getArrow(order.Name)}</>
                              </div> 
                            
                            { FEATURE_Phase_2_MERGE_CME ?
                            <div  style={{float: "right",flex:'2', textAlign:'center',minWidth:'232px'}} className='box-inner-header'> Name</div>
                            :
                            <div  style={{float: "right",paddingRight:'91px', textAlign:'center'}} className='box-inner-header'> Admin Name</div>   
                            }

                            <div  style={{float: "right", flex:'2 1 4%',minWidth:'140px' ,paddingRight:'10px'}} className='box-inner-header ' onClick={() => handleClick("Date")}> Deletion Date<> {getArrow(order.Date)}</></div>
                            
                            { FEATURE_Phase_2_MERGE_CME && <div  style={{float: "right",flex:'0.5', textAlign:'center',minWidth:'60px'}} className='box-inner-header'> Restore</div> }
                            
                         
                          
                        </div> 
                        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                { 
                                
                                DeletedActivitesList.map((item, index) => 
                                    {                                   

                                        return(
                                                <div key={shortid.generate()} className='dvMostRecentList'>
                                                    <ListItem key={shortid.generate()} alignItems="flex-start" sx={{paddingTop:"0px"  }}>
                                            
                                                        <ListItemText className='deletedListItem'  key={shortid.generate()}
                                                        primary=
                                                        {
                                                            <React.Fragment >                                                        

                                                             <Typography component="div"  style={{flex:'6',float:'left',width:FEATURE_Phase_2_MERGE_CME ? 'calc(80% - 400px)':'calc(95% - 400px)',marginLeft:'3%'}}  className="RequirementTitle box-inner-left-text " >
                                                            {item.DeletedActivityName}
                                                            </Typography>

                                                            <Typography component="div" style={{flex:'2',float:'right', textAlign:'center',minWidth:'232px' }}   className="RequirementTitle deleted-record-adminname-right-margin box-inner-left-text " >
                                                                {item.DeletedByAdminName}
                                                                
                                                                </Typography>

                                                            <Typography component="div" style={{textAlign:'center', flex:'2 1 4%',float:'right',minWidth:'140px',paddingRight:'10px'}}  className="RequirementTitle deleted-record-date-right-padding box-inner-left-text unclaim-dateRow" >
                                                                {item.DeletedByAdminDate}
                                                                
                                                                </Typography>                                               

                                                               
                                                           { FEATURE_Phase_2_MERGE_CME && <Typography component="div" 
                                                           style={{flex:'0.5',float:'right',marginRight:'3%',textAlign:'center',minWidth:'60px'}}   className="RequirementTitle  box-inner-left-text " >
                                                                
                                                                 <Container
                                                                  modalFor="RestoreDeletedActivity"
                                                                  triggerText="RestoreDeletedActivity"
                                                                  modalHeaderText="Restore Deleted Activity"
                                                                  
                                                                  onSubmit={(ev:any) => { RestoreDeletedActivity(ev,item.CmeTrackingId)}}
                                                                  // closeModal={props.closeModal}
                                                                />
                                                                
                                                                </Typography>
                                                        }
                                                               
                                                               
                                                                
                                                            </React.Fragment>
                                                        }
                                                        
                                                      
                                                        />
                                                    </ListItem>
                                                </div>                         

                                                ) 
                                        })                   
                            }
                            </List>  
                       
                    </div>
                       </>
                  </div>  
                  :  null}

    {DeletedActivitesList && DeletedActivitesList.length === 0 ? (
        <div className="EmptyList">
            <>
                {props.spinner ? (
                    <div className="spinner"></div>
                ) : (
                    <>
                        <div className="empty-text">
                            This user does not have any deleted records.
                        </div>
                        <img src={EmptyProgress} alt="Loading" />
                    </>
                )}
            </>
        </div>
    ) : null}

                   
                    
                    
                
                </div>
            </div>

           
            
        </div>
    
    </div>
      <Stack className="stackMsg" spacing={2} sx={{ width: "100%" }}>
      <Snackbar
        open={openAlertMsg}
        autoHideDuration={5000}
        onClose={() => setOpenAlertMsg(false)}
      >
        <Alert severity="info" sx={{ width: "100%" }}>
          {msg}
        </Alert>
      </Snackbar>
    </Stack>
  </>
  )

}

export default function DeletedActivities() {
  const [spinner, setSpinner] = useState(true);
  
  const enableObject={
    opacity:1, 
    pointer:'auto'
  }
  const disableObject =  {
    opacity:0.5, 
    pointer:'none'
  }
  const [progressStyles, setprogressStyles] = useState(disableObject);
  React.useEffect(() => {
    let timeout: NodeJS.Timeout | undefined;
    if(!timeout){
      
    timeout = setTimeout(() => {
      setSpinner(false);
     
      setprogressStyles(enableObject);
    }, 3000);
    }

    return () => {
      // cancel the dashboard
      clearTimeout(timeout);
  };
  
},[])


  return(   
      <>     
      
      {spinner? 
      <div className="spinner">
      </div>
      :
      null
      }
      
      <DeletedActivitiesByAdmin
        progressStyles={progressStyles}
        spinner={spinner}
        showSpinner={(toShow: boolean) => {
         
          if(toShow){
            setprogressStyles(disableObject);
          }else{
            setprogressStyles(enableObject);
            }
          
          setSpinner(toShow);
          
        }}
      />  </>                                
    );    
}